// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 1800px) {
  .dash_user_sec {
    flex-wrap: nowrap;
  }
}

@media (max-width: 767.98px) {
  .login_wrap {
    max-width: 100%;
    min-height: auto;
    display: flex;
    flex-direction: column;
  }
  .login_content {
    max-width: 100%;
    width: 100%;
    border-left: 0;
    padding: 10px;
  }
}

@media (max-width: 575.98px) {
  .heading_content h3 {
    font-size: 18px;
  }
}

/* add new css after testing @responsive  */


@media (min-width: 1800px) {
  .dash_user_sec {
    flex-wrap: nowrap;
  }
}

/* \`xxl\` applies to x-large devices (large desktops, less than 1400px) */
@media (max-width: 1600px) {
  .owner_login {
    height: auto;
  }
  .right-side {
    height: auto;
  }
  .customer_left {
    height: 100vh;
  }
}

/* \`xl\` applies to large devices (desktops, less than 1200px) */
@media (max-width: 1199.98px) {
  .owner_login {
    height: auto;
  }
  .right-side {
    height: auto;
  }
  .customer_left {
    height: 100vh;
  }
}

/* \`lg\` applies to medium devices (tablets, less than 992px) */
@media (max-width: 991.98px) {
  .owner_login {
    display: flex;
    flex-direction: column;
    height: auto;
  }
  .left-side,
  .right-side {
    width: 100%;
  }
  .left_content {
    padding: 20px;
  }
  .customer_left {
    height: 100vh;
  }
}

/* \`md\` applies to small devices (landscape phones, less than 768px) */
@media (max-width: 767.98px) {
  .login_wrap {
    max-width: 100%;
    min-height: auto;
    display: flex;
    flex-direction: column;
  }
  .login_content {
    max-width: 100%;
    width: 100%;
    border-left: 0;
    padding: 10px 10px 10px 0;
  }.date-picker-container span { 
    position: absolute;
    right: 10px;
    top: 6px;
}.date-picker-container {
  margin: 4px !important;
  width: 100%;
  position: relative;
}.react-datepicker-wrapper {
  width: 100%;
}.date_facility {
  width: 100%;
  max-width: 100%;
}.date-picker-icon {
  position: unset;
  right: 0;
}
}

@media (max-width: 575.98px) {
  .heading_content h3 {
    font-size: 18px;
  }
  .name_account .form-label {
    font-size: 18px;
  }
  .item_box p {
    font-size: 14px;
  }
  .item_box.active,
  .item_box:hover {
    padding: 10px;
  }
  .profile__tab {
    margin-bottom: 20px;
  }
  .profile__tab .nav-pills a {
    max-width: 100%;
  }
  .profile__content {
    padding: 0px 10px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/customerpenal/styles/responsive.css"],"names":[],"mappings":"AAAA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,WAAW;IACX,cAAc;IACd,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,2CAA2C;;;AAG3C;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,wEAAwE;AACxE;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;AACF;;AAEA,+DAA+D;AAC/D;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;AACF;;AAEA,8DAA8D;AAC9D;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;EACA;;IAEE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;;AAEA,sEAAsE;AACtE;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,WAAW;IACX,cAAc;IACd,yBAAyB;EAC3B,CAAC;IACC,kBAAkB;IAClB,WAAW;IACX,QAAQ;AACZ,CAAC;EACC,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB,CAAC;EACC,WAAW;AACb,CAAC;EACC,WAAW;EACX,eAAe;AACjB,CAAC;EACC,eAAe;EACf,QAAQ;AACV;AACA;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["@media (min-width: 1800px) {\r\n  .dash_user_sec {\r\n    flex-wrap: nowrap;\r\n  }\r\n}\r\n\r\n@media (max-width: 767.98px) {\r\n  .login_wrap {\r\n    max-width: 100%;\r\n    min-height: auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n  .login_content {\r\n    max-width: 100%;\r\n    width: 100%;\r\n    border-left: 0;\r\n    padding: 10px;\r\n  }\r\n}\r\n\r\n@media (max-width: 575.98px) {\r\n  .heading_content h3 {\r\n    font-size: 18px;\r\n  }\r\n}\r\n\r\n/* add new css after testing @responsive  */\r\n\r\n\r\n@media (min-width: 1800px) {\r\n  .dash_user_sec {\r\n    flex-wrap: nowrap;\r\n  }\r\n}\r\n\r\n/* `xxl` applies to x-large devices (large desktops, less than 1400px) */\r\n@media (max-width: 1600px) {\r\n  .owner_login {\r\n    height: auto;\r\n  }\r\n  .right-side {\r\n    height: auto;\r\n  }\r\n  .customer_left {\r\n    height: 100vh;\r\n  }\r\n}\r\n\r\n/* `xl` applies to large devices (desktops, less than 1200px) */\r\n@media (max-width: 1199.98px) {\r\n  .owner_login {\r\n    height: auto;\r\n  }\r\n  .right-side {\r\n    height: auto;\r\n  }\r\n  .customer_left {\r\n    height: 100vh;\r\n  }\r\n}\r\n\r\n/* `lg` applies to medium devices (tablets, less than 992px) */\r\n@media (max-width: 991.98px) {\r\n  .owner_login {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: auto;\r\n  }\r\n  .left-side,\r\n  .right-side {\r\n    width: 100%;\r\n  }\r\n  .left_content {\r\n    padding: 20px;\r\n  }\r\n  .customer_left {\r\n    height: 100vh;\r\n  }\r\n}\r\n\r\n/* `md` applies to small devices (landscape phones, less than 768px) */\r\n@media (max-width: 767.98px) {\r\n  .login_wrap {\r\n    max-width: 100%;\r\n    min-height: auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n  .login_content {\r\n    max-width: 100%;\r\n    width: 100%;\r\n    border-left: 0;\r\n    padding: 10px 10px 10px 0;\r\n  }.date-picker-container span { \r\n    position: absolute;\r\n    right: 10px;\r\n    top: 6px;\r\n}.date-picker-container {\r\n  margin: 4px !important;\r\n  width: 100%;\r\n  position: relative;\r\n}.react-datepicker-wrapper {\r\n  width: 100%;\r\n}.date_facility {\r\n  width: 100%;\r\n  max-width: 100%;\r\n}.date-picker-icon {\r\n  position: unset;\r\n  right: 0;\r\n}\r\n}\r\n\r\n@media (max-width: 575.98px) {\r\n  .heading_content h3 {\r\n    font-size: 18px;\r\n  }\r\n  .name_account .form-label {\r\n    font-size: 18px;\r\n  }\r\n  .item_box p {\r\n    font-size: 14px;\r\n  }\r\n  .item_box.active,\r\n  .item_box:hover {\r\n    padding: 10px;\r\n  }\r\n  .profile__tab {\r\n    margin-bottom: 20px;\r\n  }\r\n  .profile__tab .nav-pills a {\r\n    max-width: 100%;\r\n  }\r\n  .profile__content {\r\n    padding: 0px 10px;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
